export default {
  heading: 'Playfair Display',
  body: 'Open Sans, sans-serif',
  monospace: 'Menlo, monospace',
  display: 'Reenie Beanie, cursive',
  googleFonts: ['Playfair Display', 'Open Sans', 'Reenie Beanie']
  // customFamilies: [''],
  // customUrls: [''],
}
